import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { createChat } from '../../../services/chats';
import { IChat, ICreateChatPayload } from '../../../services/chats/types';

interface IProps {
  payload: ICreateChatPayload;
}
export const ThunkCreateChat = createAsyncThunk<IChat, IProps>(
  `${storeResources.CHATS}/createChat`,
  ({ payload }) => createChat(payload).then(res => res.data),
);
